import { HISTORY_LIST } from '../../stateManagment';

class HistoryHelperService {
  add(data) {
    HISTORY_LIST.next([
        data,
      ...HISTORY_LIST.getValue(),
    ])
  }


  subscribe(callBack, initialCall = true) {
    return HISTORY_LIST
  }

  get history() {
    return HISTORY_LIST.getValue();
  }
}

export const historyHelperService = new HistoryHelperService();
